module.exports = __webpack_public_path__ + "img/search-recondialition.88eef338.svg";